import axios from "axios"
export const profileDetails = (token) => async(dispatch) => {
    try {
        dispatch({type:"GET_SUPPLIER_DETAILS_PENDING"})
        const response = await axios.get("/api/supplier/profile-details", {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
       
        dispatch({type:"GET_SUPPLIER_DETAILS_FULFILLED",payload:response.data?.supplier})
        
    } catch (error) {
        dispatch({type:"GET_SUPPLIER_DETAILS_FAILED",payload:error.response.data})
    }
};
export const getSectors = () => async(dispatch) => {
    try {
      dispatch({type:"GET_SUPPLIER_SECTORS_PENDING"})
      const response = await axios.get("/api/supplier/get-sub-categories", {
      });
      dispatch({type:"GET_SUPPLIER_SECTORS_FULFILLED",payload:response.data})
    } catch (error) {
      dispatch({type:"GET_SUPPLIER_SECTORS_FAILED",payload:error.response.data})
    }
};
export const getIndustries = (sectorId) => async(dispatch) => {
    try {
      dispatch({type:"GET_SUPPLIER_INDUSTRIES_PENDING"})
        const response = await axios.get(`/api/supplier/get-sub-sub-categories/${sectorId}`, {
      });
      dispatch({type:"GET_SUPPLIER_INDUSTRIES_FULFILLED",payload:response.data}) 
    } catch (error) {
      dispatch({type:"GET_SUPPLIER_INDUSTRIES_FAILED",payload:error.response.data})
    }
};

export const updateSupplier = (token, supplierData) => async (dispatch) => {
  try {
    dispatch({ type: "UPDATE_SUPPLIER_PENDING" });

    const response = await axios.post(`/api/supplier/update-supplier`, supplierData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data',
      },
    });

    dispatch({
      type: "UPDATE_SUPPLIER_FULFILLED",
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: "UPDATE_SUPPLIER_REJECTED",
      payload: error.response,
    });
  }
};
export const requestUpdateProfile = (token, supplierData) => async (dispatch) => {
  try {
    dispatch({ type: "REQUEST_UPDATE_SUPPLIER_PENDING" });

    const response = await axios.post(`/api/supplier/request-profile-update`, supplierData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    dispatch({
      type: "REQUEST_UPDATE_SUPPLIER_FULFILLED",
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: "REQUEST_UPDATE_SUPPLIER_REJECTED",
      payload: error.response,
    });
  }
};